export default __webpack_public_path__ + "static/media/cover_solitairespider.b9e04d22.mp4";